/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ResendPatientInvitationRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ResendPatientInvitationRequestDtoFromJSON,
    ResendPatientInvitationRequestDtoToJSON,
} from '../models/index';

export interface ResendPatientInvitationByEmailRequest {
    resendPatientInvitationRequestDto: ResendPatientInvitationRequestDto;
}

/**
 * 
 */
export class UserInternalApi extends runtime.BaseAPI {

    /**
     * Resend the invitation email to a patient by email (API-key protected)
     */
    async resendPatientInvitationByEmailRaw(requestParameters: ResendPatientInvitationByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['resendPatientInvitationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'resendPatientInvitationRequestDto',
                'Required parameter "resendPatientInvitationRequestDto" was null or undefined when calling resendPatientInvitationByEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // api-key authentication
        }

        const response = await this.request({
            path: `/internal/users/resend-patient-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResendPatientInvitationRequestDtoToJSON(requestParameters['resendPatientInvitationRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resend the invitation email to a patient by email (API-key protected)
     */
    async resendPatientInvitationByEmail(requestParameters: ResendPatientInvitationByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resendPatientInvitationByEmailRaw(requestParameters, initOverrides);
    }

}
